import { Component } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup,  ReactiveFormsModule,  Validators } from '@angular/forms';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExportService } from '../shared/services/exportservice';


@Component({
  selector: 'app-semester-master',
  imports: [CommonModule,ReactiveFormsModule,MatModule,MatPaginatorModule],
  templateUrl: './semester-master.component.html',
  styleUrl: './semester-master.component.scss'
})
export class SemesterMasterComponent {
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','name','number','createdAt'],
   cols: ['sno','name','number','createdAt']
  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;

 SemesterId: string | null = null;
 
 isSemesterList=false;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
   private exportService: ExportService
 ) {
   this.formGroup = this.fb.group({
     name: ['', [Validators.required]],
     number: ['', [Validators.required]],
   });
 }

 ngOnInit(): void {
  
   this.getSemesterList();
 }

 getSemesterList_download(): void {
  this.api.get(`settings/getSemesterList`).subscribe({
    next: (response) => {
    
      if (response && response.data && response.data.length > 0) {

        this.dataSource = response.data;
        this.pagination.length = response?.totalCount || 0;
        const exportPayload = {
          filename: 'Semester_Master',
          displayedColumns: this.displayedColumns.cols,
          data: this.dataSource,
          dateField: ['createdAt'], 
          isDateMultiply: false,   
        };
      
        this.exportService.exportExcel(exportPayload);
      } else {
        console.log('No Semester found or empty Semester array');
      }
      this.isLoading = false;
    },
    error: (error) => {
      console.error('Error fetching Semester information:', error);
      this.common.notification('Error loading Semester information', true);
      this.isLoading = false;
    }
  });
}

 getSemesterList(): void {
   this.isSemesterList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getSemesterList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No Semester found or empty Semester array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching Semester information:', error);
       this.common.notification('Error loading Semester information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isSemesterList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isSemesterList=false;   
   this.SemesterId=row.id;
   this.isEdit=true;
   this.formGroup.patchValue({
     name: row.name,
     number: row.number,
   });
 }
   


 saveSemester(): void {
   this.isSemesterList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   if (this.SemesterId) {
        
     this.api.put(`settings/updateSemester/${this.SemesterId}`, formData).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/addSemester`,formData,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getSemesterList();
     this.resetForm();
   }
 }
 



 addSemester(){
   this.resetForm();
   this.isSemesterList=false;
 }
 


back(){
 this.isEdit=false;
 this.isSemesterList=true;  
 this.resetForm();
 this.SemesterId=null;
 this.getSemesterList();
}

delete(row:any)
{

 const SemesterId=row.id;
 this.api.put(`settings/deleteSemester/${SemesterId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getSemesterList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getSemesterList();
}
}
